<template>
  <v-dialog persistent v-model="dialog" max-width="1000px">
    <template v-slot:activator="{ on }">
      <v-layout justify-center align-center v-if="$route.path == '/strategies/planning'">
        <v-speed-dial
          fixed
          v-model="fab"
          bottom
          :right="$vuetify.breakpoint.mdAndUp"
          transition="scale-transition"
          :direction="$vuetify.breakpoint.mdAndUp ? 'left' : 'top'">
          <template v-slot:activator>
            <v-btn v-model="fab" color="accent" dark fab>
              <v-icon>add</v-icon>
              <v-icon>close</v-icon>
            </v-btn>
          </template>
          <v-btn
            class="text-xs-left"
            v-for="(tab, key) in addButtons"
            :key="key"
            dark
            round
            :color="tab.color"
            v-on="on"
            @click="publicType = tab"
            style
            >{{ tab.name }}</v-btn
          >
          <v-layout justify-end wrap></v-layout>
        </v-speed-dial>
      </v-layout>
    </template>
    <v-card>
      <v-card-title>
        <span :class="'headline ' + publicType.color + '--text'">{{ publicType.name }}</span>
      </v-card-title>
      <v-divider></v-divider>
      <v-layout row wrap>
        <v-flex xs12 md9>
          <v-card-text id="newStrategy" style="height: 70vh; overflow-y: auto">
            <v-container grid-list-md pa-0 ma-0 style="max-width: 100%">
              <v-layout wrap>
                <v-flex xs12 md4>
                  <v-select
                    ref="creditor"
                    label="Credor*"
                    item-value="creditor_id"
                    :disabled="isEdit"
                    item-text="name"
                    no-data-text="Sem abordagens neste credor"
                    v-model="form.creditor_id"
                    :items="creditors"
                    :selected="form.creditor_id"
                    box
                    required></v-select>
                </v-flex>
                <v-flex xs12 md4>
                  <v-select
                    v-model="form.policies_method"
                    :items="policiesItems"
                    item-text="text"
                    item-value="id"
                    box
                    small-chips
                    label="Política*"
                    clearable>
                    <template v-slot:selection="{ item, index }">
                      <span>{{ index === 0 ? item.text : ", " + item.text }}</span>
                    </template>
                  </v-select>
                </v-flex>
                <v-flex xs12 md4>
                  <v-select
                    item-value="type"
                    item-text="display"
                    label="Tipo de negociação*"
                    v-model="form.deal_type"
                    :items="deal_types"
                    box
                    required></v-select>
                </v-flex>
                <v-flex xs12 md4>
                  <v-flex xs12>
                    <h6 class="subheading">Tipo de valor</h6>
                  </v-flex>
                  <v-select
                    v-model="form.value_type"
                    :items="value_types"
                    label="Tipo de valor de negociação*"
                    required
                    box
                    item-text="display"
                    item-value="type"></v-select>
                </v-flex>
                <v-flex xs6 md4>
                  <v-layout wrap>
                    <v-flex xs12>
                      <h6 class="subheading">
                        Valor R$
                        <v-tooltip top>
                          <template v-slot:activator="{ on }">
                            <v-icon style="font-size: 18px; cursor: help" color="grey" v-on="on"
                              >help</v-icon
                            >
                          </template>
                          <small class="body-2">
                            Considerar <strong>maior ou igual</strong> que o valor mínimo e
                            <strong>menor</strong> que o valor máximo <br />
                            Ex: Minimo (20) máximo (91) para o intervalo de 20 a 90. <br />
                            * Se aplica para todos os valores compostos de intervalos.
                          </small>
                        </v-tooltip>
                      </h6>
                    </v-flex>
                    <v-flex xs6>
                      <v-text-field
                        type="number"
                        label="Mínimo"
                        name="min_debit"
                        autocomplete="off"
                        v-model="form.min_debit"
                        box />
                    </v-flex>
                    <v-flex xs6>
                      <v-text-field
                        type="number"
                        label="Máximo"
                        name="max_debit"
                        autocomplete="off"
                        v-model="form.max_debit"
                        box />
                    </v-flex>
                  </v-layout>
                </v-flex>
                <v-flex xs6 md4>
                  <v-layout wrap>
                    <v-flex xs12>
                      <h6 class="subheading">Potencial de ganho R$</h6>
                    </v-flex>
                    <v-flex xs6>
                      <v-text-field
                        type="number"
                        label="Mínimo"
                        name="min_potential"
                        autocomplete="off"
                        v-model="form.min_potential"
                        box />
                    </v-flex>
                    <v-flex xs6>
                      <v-text-field
                        type="number"
                        label="Máximo"
                        name="max_potential"
                        autocomplete="off"
                        v-model="form.max_potential"
                        box />
                    </v-flex>
                  </v-layout>
                </v-flex>

                <v-flex xs12 md6>
                  <v-layout wrap>
                    <v-flex xs12>
                      <h6 class="subheading">Desconto</h6>
                    </v-flex>
                    <v-flex xs6>
                      <v-text-field
                        type="text"
                        label="Mínimo"
                        suffix="%"
                        autocomplete="off"
                        mask="###"
                        name="min_discount"
                        v-model="formattedMinDiscount"
                        box
                        hint
                        single-line />
                    </v-flex>
                    <v-flex xs6>
                      <v-text-field
                        type="text"
                        label="Máximo"
                        suffix="%"
                        autocomplete="off"
                        mask="###"
                        name="max_discount"
                        v-model="formattedMaxDiscount"
                        box
                        hint
                        single-line />
                    </v-flex>
                  </v-layout>
                </v-flex>
                <v-flex xs12 md6>
                  <v-layout wrap>
                    <v-flex xs12>
                      <h6 class="subheading">Dias de atraso</h6>
                    </v-flex>
                    <v-flex xs6>
                      <v-text-field
                        type="number"
                        label="Mínimo"
                        autocomplete="off"
                        name="min_days_of_delay"
                        v-model="form.min_days_of_delay"
                        box />
                    </v-flex>
                    <v-flex xs6>
                      <v-text-field
                        type="number"
                        label="Máximo"
                        autocomplete="off"
                        name="max_days_of_delay"
                        v-model="form.max_days_of_delay"
                        box />
                    </v-flex>
                  </v-layout>
                </v-flex>
                <v-flex xs12 md6>
                  <v-layout wrap>
                    <v-flex xs12>
                      <h6 class="subheading">
                        Qualidade
                        <v-tooltip top>
                          <template v-slot:activator="{ on }">
                            <v-icon style="font-size: 18px; cursor: help" color="grey" v-on="on"
                              >help</v-icon
                            >
                          </template>
                          <small>
                            A qualidade de um contato novo começa em
                            <strong>0</strong>. <br />Valores menores que <strong>1</strong> são
                            considerados de baixa qualidade. <br />Ex:
                            <strong>0, 0.10, 0.25, 0.50, 0.80, 1</strong>
                          </small>
                        </v-tooltip>
                      </h6>
                    </v-flex>
                    <v-flex xs6>
                      <v-text-field
                        type="number"
                        label="Mínima"
                        autocomplete="off"
                        name="contact_min_final_score"
                        v-model="form.contact_min_final_score"
                        box
                        hint
                        single-line />
                    </v-flex>
                    <v-flex xs6>
                      <v-text-field
                        type="number"
                        label="Máxima"
                        autocomplete="off"
                        name="contact_max_final_score"
                        v-model="form.contact_max_final_score"
                        box
                        hint
                        single-line />
                    </v-flex>
                  </v-layout>
                </v-flex>
                <v-flex xs12 md6>
                  <v-layout wrap>
                    <v-flex xs12>
                      <h6 class="subheading">Digito Verificador</h6>
                    </v-flex>
                    <v-flex xs6>
                      <v-text-field
                        type="number"
                        :max="100"
                        :min="0"
                        label="De"
                        autocomplete="off"
                        name="min_digit"
                        v-model="form.min_digit"
                        box />
                    </v-flex>
                    <v-flex xs6>
                      <v-text-field
                        type="number"
                        :max="100"
                        :min="0"
                        label="Até"
                        autocomplete="off"
                        name="max_digit"
                        v-model="form.max_digit"
                        box />
                    </v-flex>
                  </v-layout>
                </v-flex>

                <v-flex xs12 v-if="publicType.value !== 'IMPORTED'">
                  <h6 class="subheading">
                    Dias desde a última interação
                    <v-tooltip top>
                      <template v-slot:activator="{ on }">
                        <v-icon style="font-size: 18px; cursor: help" color="grey" v-on="on"
                          >help</v-icon
                        >
                      </template>
                      <small class="body-2">
                        <strong>
                          Ao selecionar "Sem Interação" nenhum filtro será considerado e o público
                          será quem nunca interagiu.</strong
                        ><br />
                        Inclusão de ranges de interação, onde [x] é definido como: clientes que
                        interagiram pela última vez DE: [0] dias ATÉ: [30] dias.
                      </small>
                    </v-tooltip>
                  </h6>
                </v-flex>
                <v-flex
                  xs12
                  :class="publicType.value === 'LOCATED' ? 'md4' : 'md4'"
                  v-if="publicType.value !== 'IMPORTED'">
                  <v-layout row wrap>
                    <v-switch v-model="form.exclude_interactions" label="Sem interação"></v-switch>
                  </v-layout>
                </v-flex>
                <v-flex
                  xs12
                  :class="publicType.value === 'LOCATED' ? 'md4' : 'md4'"
                  v-if="publicType.value !== 'IMPORTED'">
                  <v-text-field
                    v-model="form.max_interaction_days"
                    type="number"
                    suffix="dias"
                    hint="Dias desde o último clique no link"
                    autocomplete="off"
                    name="max_interaction_days"
                    label="Interação de:"
                    :disabled="form.exclude_interactions"
                    box 
                  />
                </v-flex>
                <v-flex
                  xs12
                  :class="publicType.value === 'LOCATED' ? 'md4' : 'md4'"
                  v-if="publicType.value !== 'IMPORTED'">
                  <v-text-field
                    v-model="form.min_interaction_days"
                    type="number"
                    suffix="dias"
                    hint="Dias desde o último clique no link"
                    autocomplete="off"
                    name="min_interaction_days"
                    label="Interação até:"
                    :disabled="form.exclude_interactions"
                    box
                  />
                </v-flex>

                <v-flex xs12>
                  <h6 class="subheading">Configurações</h6>
                </v-flex>

                <v-flex
                  xs12
                  :class="publicType.value === 'LOCATED' ? 'md4' : 'md4'"
                  v-if="publicType.value !== 'IMPORTED'">
                  <v-text-field
                    type="number"
                    autocomplete="off"
                    name="days_to_wait"
                    label="Dias de espera*"
                    v-model="form.days_to_wait"
                    box />
                </v-flex>

                <v-flex
                  xs12
                  :class="publicType.value === 'LOCATED' ? 'md4' : 'md4'"
                  v-if="publicType.value !== 'IMPORTED'">
                  <v-text-field
                    v-model="form.min_notifications"
                    label="Mínimo de notificações"
                    autocomplete="off"
                    type="number"
                    box
                    name="min_notifications" />
                </v-flex>

                <v-flex
                  xs12
                  :class="publicType.value === 'LOCATED' ? 'md4' : 'md4'"
                  v-if="publicType.value !== 'IMPORTED'">
                  <v-text-field
                    type="number"
                    autocomplete="off"
                    name="max_notifications"
                    label="Máximo de notificações"
                    v-model="form.max_notifications"
                    box />
                </v-flex>

                <v-flex
                  xs6
                  :class="
                    publicType.value === 'IMPORTED'
                      ? ''
                      : publicType.value === 'LOCATED'
                      ? 'md6'
                      : 'md6'
                  ">
                  <v-text-field
                    name="limit"
                    type="number"
                    autocomplete="off"
                    label="Limite de notificações"
                    hint="Deixe em branco para não ter limite"
                    v-model="form.limit"
                    box />
                </v-flex>

                <v-flex xs6>
                  <v-select
                    box
                    :items="[1, 2, 3, 4, 5]"
                    label="Qtd. máx. de contatos"
                    v-model="form.max_contact_count"
                    clearable>
                    <template v-slot:prepend-inner>
                      <v-tooltip top>
                        <template v-slot:activator="{ on }">
                          <v-icon
                            style="font-size: 20px; cursor: help; margin-top: 2px"
                            color="grey"
                            v-on="on"
                            >help</v-icon
                          >
                        </template>
                        <p>Limita a quantidade de contatos a serem notificados por cliente</p>
                      </v-tooltip>
                    </template>
                  </v-select>
                </v-flex>

                <v-flex xs12>
                  <v-layout wrap>
                    <v-flex xs12>
                      <h6 class="subheading">Dias desde o último acordo expirado</h6>
                    </v-flex>

                    <v-flex xs6>
                      <v-text-field
                        type="number"
                        label="Quebra de:"
                        suffix="dias"
                        autocomplete="off"
                        name="max_payment_expired_days"
                        min="0"
                        v-model="form.max_payment_expired_days"
                        box />
                    </v-flex>

                    <v-flex xs6>
                      <v-text-field
                        type="number"
                        label="Quebra até:"
                        suffix="dias"
                        autocomplete="off"
                        name="min_payment_expired_days"
                        min="0"
                        v-model="form.min_payment_expired_days"
                        box />
                    </v-flex>
                  </v-layout>
                </v-flex>

                <v-flex xs12>
                  <v-select
                    item-value="type"
                    item-text="multi"
                    label="Abordar Credor"
                    v-model="form.multicreditor"
                    :items="multicreditors"
                    box
                    required></v-select>
                </v-flex>
                <v-flex xs12 md6>
                  <v-combobox
                    box
                    multiple
                    clearable
                    hide-details
                    small-chips
                    name="creditor_profiles"
                    label="Chave de perfil de credor"
                    :items="
                      creditoProfilesFilter.length > 1 ? creditoProfilesFilter : creditor_profiles
                    "
                    item-text="name"
                    v-model="profileKeyModel">
                    <template v-slot:no-data="{ item, index }">
                      {{ item.name }}
                    </template>
                  </v-combobox>
                </v-flex>

                <v-flex xs12 md6>
                  <v-select
                    clearable
                    box
                    name="campaign_v2"
                    label="Campanhas"
                    :items="campaigns"
                    v-model="form.campaign_v2">
                  </v-select>
                </v-flex>

                <v-flex xs12 md6>
                  <v-combobox
                    box
                    required
                    hide-details
                    clearable
                    small-chips
                    item-text="name"
                    label="Segmentos"
                    :items="SegmentFilter.length > 1 ? SegmentFilter : segments"
                    v-model="segmentChip"
                    multiple>
                    <template v-slot:no-data="{ item, index }">
                      {{ item.name }}
                    </template>
                  </v-combobox>
                </v-flex>

                <v-flex xs12 md6>
                  <v-select
                    box
                    multiple
                    clearable
                    small-chips
                    name="amount_deals"
                    label="Quantidade de Deals"
                    v-model="amountDealsModel"
                    :items="['1', '2', '3', '4', '>=5']">
                    <template v-slot:no-data></template>
                  </v-select>
                </v-flex>

                <v-flex xs12 v-if="publicType.value !== 'LOCATED'">
                  <h6 class="subheading">Enriquecimento de contatos</h6>
                </v-flex>
                <v-flex xs12 class="mb-2" v-if="publicType.value !== 'LOCATED'">
                  <v-layout row wrap>
                    <v-switch
                      v-model="form.only_enrichment"
                      color="blue"
                      @change="form.not_only_enrichment = false"
                      label="Enriquecidos"></v-switch>
                    <v-switch
                      v-model="form.not_only_enrichment"
                      color="red"
                      @change="form.only_enrichment = false"
                      label="Não enriquecidos"></v-switch>
                  </v-layout>
                </v-flex>
                <v-flex xs12 class="mb-2">
                  <header v-if="publicType.value == 'UNCHECKED'">
                    <h6 class="subheading">Confirmação de envio de notificações</h6>
                  </header>

                  <v-layout row wrap v-if="publicType.value == 'UNCHECKED'">
                    <v-switch
                      v-model="form.only_notification_sent"
                      color="blue"
                      @change="form.not_only_notification_sent = false"
                      label="Com confirmação"></v-switch>
                    <v-switch
                      v-model="form.not_only_notification_sent"
                      color="red"
                      @change="form.only_notification_sent = false"
                      label="Sem confirmação"></v-switch>
                  </v-layout>
                </v-flex>
                <v-flex xs12>
                  <v-select
                    name="ddd"
                    label="DDDs"
                    autocomplete="off"
                    hint="Deixe em branco para considerar todos os DDDs."
                    v-model="selected_ddd"
                    :items="ddds"
                    box
                    multiple
                    clearable
                    small-chips>
                    <template v-slot:no-data></template>
                  </v-select>
                </v-flex>
                <v-flex xs12>
                  <h6 class="subheading">Tags</h6>
                </v-flex>

                <v-flex xs12>
                  <v-combobox
                    box
                    multiple
                    clearable
                    small-chips
                    name="tags_v2"
                    label="Tags da Negociação - campo inclusivo"
                    :items="tagsFilter.length > 1 ? tagsFilter : tags_v2"
                    item-text="name"
                    v-model="dealTagsModelV2">
                    <template v-slot:no-data="{ item, index }">
                      {{ item.name }}
                    </template>
                  </v-combobox>
                </v-flex>

                <v-flex class="mb-4" xs12>
                  <v-combobox
                    box
                    multiple
                    clearable
                    small-chips
                    hide-selected
                    hide-details
                    autocomplete="off"
                    name="contact_tags_v2"
                    label="Tags de Contato"
                    hint="Deixe em branco para não considerar negociações com tags."
                    v-model="contactTagsV2"
                    item-text="name"
                    :items="contactTagsFilter.length > 1 ? contactTagsFilter : contact_tags_v2">
                    <template v-slot:no-data="{ item, index }">
                      {{ item.name }}
                    </template>
                  </v-combobox>
                </v-flex>

                <v-flex class="mb-2" xs12>
                  <v-combobox
                    box
                    multiple
                    clearable
                    small-chips
                    hide-selected
                    hide-details
                    autocomplete="off"
                    name="customer_tag"
                    label="Tags de Cliente"
                    hint="Deixe em branco para não considerar negociações com tags."
                    v-model="customerTagsV2"
                    item-text="name"
                    :items="customerTagsFilter.length > 1 ? customerTagsFilter : customer_tag">
                    <template v-slot:no-data="{ item, index }">
                      {{ item.name }}
                    </template>
                  </v-combobox>
                </v-flex>

                <v-flex xs12 class="md3">
                  <v-layout wrap>
                    <v-flex xs12>
                      <h6 class="subheading">Condições</h6>
                    </v-flex>
                    <v-flex :class="publicType.value !== 'IMPORTED' ? 'xs12' : 'xs12'">
                      <v-select
                        v-model="conditions"
                        :items="setConditionsItems(publicType.value)"
                        item-text="text"
                        item-value="id"
                        box
                        chips
                        small-chips
                        label="Condições"
                        multiple
                        clearable>
                        <template v-slot:selection="{ item, index }">
                          <span v-if="index <= 0">{{ item.text }}</span>
                          <span
                            v-if="index === 1"
                            style="padding-left: 5px"
                            class="grey--text caption">
                            (+{{
                              conditions.length -
                              1 +
                              (conditions.length == 2 ? " outro)" : " outros)")
                            }}
                          </span>
                        </template>
                      </v-select>
                    </v-flex>
                  </v-layout>
                </v-flex>
                <v-flex xs12 class="md3">
                  <v-layout wrap>
                    <v-flex xs12>
                      <h6 class="subheading">Contatos</h6>
                    </v-flex>
                    <v-flex xs12>
                      <v-select
                        :items="[
                          {
                            id: 'OWNER',
                            text: 'Próprio',
                          },
                          {
                            id: 'ASSOCIATE',
                            text: 'Sócios',
                          },
                          {
                            id: 'GUARANTOR',
                            text: 'Avalistas',
                          },
                        ]"
                        v-model="responsible_types"
                        item-text="text"
                        item-value="id"
                        box
                        small-chips
                        clearable
                        label="Contatos"
                        multiple>
                        <template v-slot:selection="{ item, index }">
                          <span>{{ index === 0 ? item.text : ", " + item.text }}</span>
                        </template>
                      </v-select>
                    </v-flex>
                  </v-layout>
                </v-flex>
                <v-flex xs12 class="md3">
                  <v-layout wrap>
                    <v-flex xs12>
                      <h6 class="subheading">Origem dos contatos</h6>
                    </v-flex>
                    <v-flex xs12>
                      <v-select
                        :items="[
                          {
                            id: 'CREDITOR',
                            text: 'Credor',
                          },
                          {
                            id: 'PARTNER',
                            text: 'Enriquecimento',
                          },
                          {
                            id: 'CUSTOMER',
                            text: 'Cliente',
                          },
                          {
                            id: 'OPERATOR',
                            text: 'Backoffice',
                          },
                        ]"
                        v-model="contact_source"
                        item-text="text"
                        item-value="id"
                        box
                        small-chips
                        clearable
                        label="Contatos"
                        multiple>
                        <template v-slot:selection="{ item, index }">
                          <span>{{ index === 0 ? item.text : ", " + item.text }}</span>
                        </template>
                      </v-select>
                    </v-flex>
                  </v-layout>
                </v-flex>
              </v-layout>
            </v-container>
          </v-card-text>
        </v-flex>
        <v-flex xs12 md3>
          <v-card-text id="newStrategy" style="height: 70vh; overflow-y: auto">
            <v-layout justify-space-between column fill-height>
              <v-layout wrap>
                <v-menu
                  max-width="290px"
                  min-width="290px"
                  transition="scale-transition"
                  :nudge-right="40"
                  class="ma-0 pa-0"
                  :close-on-content-click="true"
                  lazy
                  offset-y
                  full-width>
                  <v-text-field
                    slot="activator"
                    v-model="dateFormatted"
                    name="last_import_since"
                    class="ma-0 pa-0"
                    @blur="last_import_since = parseDate(dateFormatted)"
                    @paste="last_import_since = parseDate(dateFormatted)"
                    label="Última importação desde*"
                    prepend-inner-icon="mdi-calendar-range"
                    :value="last_import_sinceFormatted"
                    box
                    required></v-text-field>
                  <v-date-picker
                    locale="pt-br"
                    class="ma-0 pa-0"
                    v-model="last_import_since"
                    actions
                    no-title
                    scrollable></v-date-picker>
                </v-menu>

                <v-btn
                  :loading="loadingSimulation"
                  :disabled="!isValidToSimulate"
                  block
                  depressed
                  style="margin-top: -27px !important"
                  class="ma-0 pa-0"
                  color="secondary"
                  @click="taskSimulate"
                  >Simular</v-btn
                >

                <v-flex xs12 text-xs-center>
                  <!-- CONTACTS - NOTIFICATIONS -->
                  <v-layout
                    column
                    wrap
                    :style="simulationNotification != null ? 'background-color: #dddddd' : ''">
                    <h6
                      class="subheading my-1 font-weight-bold"
                      :style="simulationNotification == null ? 'color: #ffffff' : ''">
                      Notificações
                    </h6>
                    <p
                      class="subheading"
                      style="
                        z-index: 2;
                        line-height: 16px;
                        padding-top: 5px !important;
                        margin-bottom: -10px !important;
                      ">
                      <small
                        v-if="simulationNotification != null"
                        :style="`font-size:16px;${
                          oldSimulationNotification != null ? '' : 'color:#dddddd'
                        }`"
                        >{{ oldSimulationNotification | numeral("0,0") }}</small
                      >
                    </p>
                    <v-chip
                      label
                      :style="`
                                        width: 100%;
                                        justify-content: center;
                                        margin: 0;
                                        ${
                                          simulationNotification != null
                                            ? 'background-color: #dddddd'
                                            : 'background-color: #ffffff'
                                        }
                                        padding:0;
                                        position: relative;
                                    `">
                      <p v-if="diffSimulationNotification < 0">
                        {{ "-" }}
                        {{ (diffSimulationNotification * -1) | numeral("0,0") }}
                      </p>
                      <p v-if="oldSimulationNotification != null && diffSimulationNotification > 0">
                        {{ "+" }}
                        {{ diffSimulationNotification | numeral("0,0") }}
                      </p>
                      <p v-if="diffSimulationNotification == 0">
                        {{ diffSimulationNotification | numeral("0,0") }}
                      </p>
                      <v-scroll-y-reverse-transition>
                        <span
                          v-if="activeIconSimulationNotificationUp"
                          style="
                            position: absolute;
                            top: 0;
                            right: 15px;
                            height: 100%;
                            width: 32px;
                          ">
                          <v-icon
                            v-if="oldSimulationNotification != null"
                            style="font-size: 30px"
                            color="green"
                            >mdi-arrow-up-bold</v-icon
                          >
                        </span>
                      </v-scroll-y-reverse-transition>
                      <v-scroll-y-transition>
                        <span
                          v-if="activeIconSimulationNotificationDown"
                          style="
                            position: absolute;
                            top: 0;
                            right: 15px;
                            height: 100%;
                            width: 32px;
                          ">
                          <v-icon style="font-size: 30px" color="red">mdi-arrow-down-bold</v-icon>
                        </span>
                      </v-scroll-y-transition>
                    </v-chip>
                    <p
                      class="title mb-2 font-weight-bold"
                      :style="simulationNotification != null ? '' : 'color: #ffffff'"
                      ref="simulation">
                      {{ simulationNotification | numeral("0,0") }}
                    </p>
                  </v-layout>
                </v-flex>
                <!-- CUSTOMERS -->
                <v-flex xs12 text-xs-center>
                  <v-layout
                    column
                    wrap
                    :style="simulationCustomers != null ? 'background-color: #dddddd' : ''">
                    <h6
                      class="subheading my-1 font-weight-bold"
                      :style="simulationCustomers == null ? 'color: #ffffff' : ''">
                      Clientes
                    </h6>
                    <p
                      class="subheading"
                      style="
                        z-index: 2;
                        line-height: 16px;
                        padding-top: 5px !important;
                        margin-bottom: -10px !important;
                      ">
                      <small
                        v-if="simulationCustomers != null"
                        :style="`font-size:16px;${
                          oldSimulationCustomers != null ? '' : 'color:#dddddd'
                        }`">
                        {{ oldSimulationCustomers | numeral("0,0") }}</small
                      >
                    </p>
                    <v-chip
                      label
                      :style="`
                                        width: 100%;
                                        ${
                                          simulationCustomers != null
                                            ? 'background-color: #dddddd'
                                            : 'background-color: #ffffff'
                                        }
                                        padding: 0;
                                        justify-content: center;
                                        font-size: 18px;
                                        margin: 0;
                                    `">
                      <p v-if="diffSimulationCustomers < 0">
                        {{ "-" }}
                        {{ (diffSimulationCustomers * -1) | numeral("0,0") }}
                      </p>
                      <p v-if="oldSimulationCustomers && diffSimulationCustomers > 0">
                        {{ "+" }} {{ diffSimulationCustomers | numeral("0,0") }}
                      </p>
                      <p v-if="diffSimulationCustomers == 0">
                        {{ diffSimulationCustomers | numeral("0,0") }}
                      </p>
                      <v-scroll-y-reverse-transition>
                        <span
                          v-if="activeIconSimulationCustomersUp"
                          style="
                            position: absolute;
                            top: 0;
                            right: 15px;
                            height: 100%;
                            width: 32px;
                          ">
                          <v-icon
                            v-if="oldSimulationCustomers != null"
                            style="font-size: 30px"
                            color="green"
                            >mdi-arrow-up-bold</v-icon
                          >
                        </span>
                      </v-scroll-y-reverse-transition>
                      <v-scroll-y-transition>
                        <span
                          v-if="activeIconSimulationCustomersDown"
                          style="
                            position: absolute;
                            top: 0;
                            right: 15px;
                            height: 100%;
                            width: 32px;
                          ">
                          <v-icon style="font-size: 30px" color="red">mdi-arrow-down-bold</v-icon>
                        </span>
                      </v-scroll-y-transition>
                    </v-chip>
                    <p
                      class="title mb-2 font-weight-bold"
                      :style="simulationCustomers != null ? '' : 'color: #ffffff'"
                      ref="customers">
                      {{ simulationCustomers | numeral("0,0") }}
                    </p>
                  </v-layout>
                </v-flex>
              </v-layout>
              <v-layout justify-center>
                <p
                  :style="simulationFailureText ? 'color: red' : 'color:white'"
                  class="font-weight-bold">
                  {{ simulationFailureText ? simulationFailureText : "-" }}
                </p>
              </v-layout>
              <v-spacer></v-spacer>
              <v-spacer></v-spacer>
              <v-layout column justify-end>
                <v-flex>
                  <v-text-field
                    name="name"
                    label="Nome*"
                    maxlength="80"
                    value="Nova estratégia"
                    v-model="form.name"
                    box
                    counter
                    required
                    class="mb-2" />
                  <v-select
                    name="typeApproach"
                    label="Tipo da abordagem*"
                    v-model="form.typeApproach"
                    box
                    required
                    :items="['SMS', 'PUSH']"
                    :selected="form.typeApproach"></v-select>
                  <v-autocomplete
                    item-value="id"
                    item-text="name"
                    name="approaches"
                    label="Abordagem*"
                    hide-details
                    no-data-text="Nenhuma abordagem."
                    v-model="form.approach_id"
                    :items="setApproaches"
                    :disabled="approaches.length == 0 || !form.typeApproach"
                    box
                    required>
                    <template v-slot:selection="data">
                      <div class="truncate" style="width: 100%">
                        <span :class="`tag-approach-type small mr-1 ${data.item.type}`">{{
                          data.item.type
                        }}</span>
                        {{ data.item.name }}
                      </div>
                    </template>

                    <template v-slot:item="data">
                      <v-layout row justify-space-between>
                        <span>{{ data.item.name }}</span>
                        <span
                          :class="`tag-approach-type small ${data.item.type}`"
                          style="margin-top: auto; margin-bottom: auto"
                          >{{ data.item.type }}</span
                        >
                      </v-layout>
                    </template>
                  </v-autocomplete>
                </v-flex>
              </v-layout>
            </v-layout>
          </v-card-text>
        </v-flex>
      </v-layout>
      <v-divider></v-divider>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="blue darken-1" flat @click="dialog = false">Fechar</v-btn>
        <v-btn color="blue darken-1" flat @click="saveStrategy()" :disabled="!isValidForm"
          >Salvar</v-btn
        >
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import moment from "moment";
import store from "@/store";
import tasksService from "@/services/tasks";
import { EventBus } from "@/services/event-bus";
import strategyPublic from "@/utils/strategy-public";
import creditorService from "@/services/creditor";
import strategyService from "@/services/strategy";

export default {
  props: [
    "segments",
    "campaigns",
    "creditor_profiles",
    "creditoProfilesFilter",
    "tags_v2",
    "tagsFilter",
    "contact_tags_v2",
    "customer_tag",
    "contactTagsFilter",
    "customerTagsFilter",
    "approaches",
  ],
  beforeMount() {
    let vm = this;
    EventBus.$on("edit", async (data) => {
      vm.isEdit = true;
      if (data.id) {
        await vm.getStrategy(data.id);
      } else {
        vm.loadStrategy(data);
      }
    });
  },
  beforeDestroy: function () {
    EventBus.$off("edit");
  },
  created() {
    this.addButtons = [].concat(strategyPublic.strategyPublic).reverse();
    this.form = Object.assign({}, this.strategyBlank);
  },
  data() {
    return {
      addButtons: [],
      iconSimulation: "north",
      fab: false,
      isEdit: false,
      dialog: false,
      loadingSimulation: false,
      simulationFailureText: null,
      activeIconSimulationNotificationUp: false,
      activeIconSimulationNotificationDown: false,
      activeIconSimulationCustomersUp: false,
      activeIconSimulationCustomersDown: false,
      publicType: {},
      creditors: [],
      ddds: [
        { header: "Inclusão" },
        "11",
        "12",
        "13",
        "14",
        "15",
        "16",
        "17",
        "18",
        "19",
        "21",
        "22",
        "24",
        "27",
        "28",
        "31",
        "32",
        "33",
        "34",
        "35",
        "37",
        "38",
        "41",
        "42",
        "43",
        "44",
        "45",
        "46",
        "47",
        "48",
        "49",
        "51",
        "53",
        "54",
        "55",
        "61",
        "62",
        "63",
        "64",
        "65",
        "66",
        "67",
        "68",
        "69",
        "71",
        "73",
        "74",
        "75",
        "77",
        "79",
        "81",
        "82",
        "83",
        "84",
        "85",
        "86",
        "87",
        "88",
        "89",
        "91",
        "92",
        "93",
        "94",
        "95",
        "96",
        "97",
        "98",
        "99",
        { header: "Exclusão" },
        "-11",
        "-12",
        "-13",
        "-14",
        "-15",
        "-16",
        "-17",
        "-18",
        "-19",
        "-21",
        "-22",
        "-24",
        "-27",
        "-28",
        "-31",
        "-32",
        "-33",
        "-34",
        "-35",
        "-37",
        "-38",
        "-41",
        "-42",
        "-43",
        "-44",
        "-45",
        "-46",
        "-47",
        "-48",
        "-49",
        "-51",
        "-53",
        "-54",
        "-55",
        "-61",
        "-62",
        "-63",
        "-64",
        "-65",
        "-66",
        "-67",
        "-68",
        "-69",
        "-71",
        "-73",
        "-74",
        "-75",
        "-77",
        "-79",
        "-81",
        "-82",
        "-83",
        "-84",
        "-85",
        "-86",
        "-87",
        "-88",
        "-89",
        "-91",
        "-92",
        "-93",
        "-94",
        "-95",
        "-96",
        "-97",
        "-98",
        "-99",
      ],
      form: {},
      strategyBlank: {
        name: "Nova estratégia",
        typeApproach: "SMS",
        days_to_wait: 0,
        personal: false,
        business: false,
        active: true,
        apply_tags: false,
        exclude_interactions: false,
        contact_tags_v2: "",
        customer_tag: "",
        selected_ddd: "",
        deal_type: "NEGOTIATION",
        multicreditor: "ALL",
        value_type: "NEGOTIATION",
        responsible_types: "",
        payment_methods: "",
        contact_source: "",
        ddd_method: null,
        min_payment_expired_days: null,
        max_payment_expired_days: null,
        only_notification_sent: true,
        last_import_since: new Date().toISOString(),
        indicator_bad_accessed: 0.015,
        indicator_good_accessed: 0.03,
        indicator_bad_implantation: 0.85,
        indicator_good_implantation: 0.9,
        indicator_good_cpp: 12,
        indicator_bad_cpp: 18,
        indicator_good_interest: 0.15,
        indicator_bad_interest: 0.1,
        workspace: "PLANNING",
      },
      conditions: [],
      selected_ddd: [],
      dddItems: [],
      contactTagsV2: [],
      customerTagsV2: [],
      amountDealsModel: [],
      profileKeyModel: [],
      dealTagsModelV2: [],
      adapterUpdated: false,
      segmentChip: [],
      payment_methods: [],
      contactTagsModel: [],
      customerTagsModel: [],
      responsible_types: [],
      contact_source: [],
      deal_types: [
        {
          type: "NEGOTIATION",
          display: "Normal",
        },
        {
          type: "RENEGOTIATION",
          display: "Renegociação",
        },
        {
          type: "FOMENTATION",
          display: "Fomento",
        },
        {
          type: "DATALESS",
          display: "Sem Dados",
        },
      ],
      multicreditors: [
        {
          type: "ALL",
          multi: "Todos",
        },
        {
          type: "SINGLE",
          multi: "Credor único",
        },
        {
          type: "MULTI",
          multi: "Multi credores",
        },
      ],
      value_types: [
        {
          type: "NEGOTIATION",
          display: "Valor presente",
        },
        {
          type: "BOOK",
          display: "Valor contábil",
        },
      ],
      paymentItens: [
        {
          id: "BOLETO",
          text: "Boleto",
        },
        {
          id: "DEBIT_CARD",
          text: "Débito automático",
        },
      ],
      policiesItems: [
        {
          id: "ONLY_POLICIES",
          text: "Com política",
        },
        {
          id: "NOT_ONLY_POLICIES",
          text: "Sem política",
        },
      ],
      stateItems: [
        "AC",
        "AL",
        "AP",
        "AM",
        "BA",
        "CE",
        "DF",
        "ES",
        "GO",
        "MA",
        "MT",
        "MS",
        "MG",
        "PA",
        "PB",
        "PR",
        "PE",
        "PI",
        "RJ",
        "RN",
        "RS",
        "RO",
        "RR",
        "SC",
        "SP",
        "SE",
        "TO",
      ],
      selectedDiscount: 0,
      simulationCustomers: null,
      simulationNotification: null,
      oldSimulationCustomers: null,
      oldSimulationNotification: null,
      diffSimulationCustomers: null,
      diffSimulationNotification: null,
      sameSimulationCustomers: false,
      sameSimulationNotification: false,
      taskId: null,
      interval: null,
      last_import_since: new Date().toISOString().substr(0, 10),
      dateFormatted: this.formatDate(new Date().toISOString().substr(0, 10)),
      SegmentFilter: [],
    };
  },

  watch: {
    last_import_since(val) {
      this.dateFormatted = this.formatDate(this.last_import_since);
    },

    async dialog() {
      let query = Object.assign({}, this.$route.query);
      if (this.dialog) {
        query.strategy_id = this.form.id ? this.form.id : "new";
        this.getCreditors();
        if (!this.isEdit) {
          this.form = Object.assign({}, this.strategyBlank);
          this.form.creditor_id = query.creditor;
          this.form.approach_id = null;
          delete this.form.approach_id;
          this.form.public = this.publicType.value;
          this.form.typeApproach = "SMS";
          this.responsible_types = [];
          this.contact_source = [];
          this.payment_methods = [];
          this.conditions = [];
          this.dealTagsModelV2 = [];
          this.contactTagsModel = [];
          this.customerTagsModel = [];
          this.selected_ddd = [];
          this.contactTagsV2 = [];
          this.customerTagsV2 = [];
          this.amountDealsModel = [];
          this.segmentChip = [];
          this.profileKeyModel = [];
          this.searchApproach(this.form.creditor_id);
          this.loadDates();
          this.loadShipsFields();
        }
        this.loading = false;
        this.simulationFailureText = null;
        this.simulationCustomers = null;
        this.simulationNotification = null;
        this.oldSimulationCustomers = null;
        this.oldSimulationNotification = null;
        this.diffSimulationCustomers = null;
        this.diffSimulationNotification = null;
        clearInterval(this.interval);
        this.loadingSimulation = false;
        this.activeIconSimulationCustomersUp = false;
        this.activeIconSimulationCustomersDown = false;
        this.activeIconSimulationNotificationUp = false;
        this.activeIconSimulationNotificationDown = false;
      } else {
        this.segmentChip = [];
        this.dealTagsModelV2 = [];
        this.profileKeyModel = [];
        this.amountDealsModel = [];
        this.SegmentFilter = [];
        this.isEdit = false;
        delete query.strategy_id;
        delete this.form.id;
      }
      this.$router.push({ query });
      document.getElementById("newStrategy").scrollTop = 0;
    },

    async dealTagsModelV2() {
      if (this.dealTagsModelV2.includes("Sem-tags") && this.dealTagsModelV2.length > 1) {
        this.dealTagsModelV2 = ["Sem-tags"];
      }
    },
    async contactTagsV2() {
      if (this.contactTagsV2.includes("Sem-tags") && this.contactTagsV2.length > 1) {
        this.contactTagsV2 = ["Sem-tags"];
      }
    },
    async customerTagsV2() {
      if (this.customerTagsV2.includes("Sem-tags") && this.customerTagsV2.length > 1) {
        this.customerTagsV2 = ["Sem-tags"];
      }
    },
  },
  computed: {
    formattedMaxDiscount: {
      get: function () {
        return this.form.max_discount ? this.form.max_discount * 100 : null;
      },
      set: function (newValue) {
        if (newValue) this.form.max_discount = newValue / 100;
        else this.form.max_discount = null;
      },
    },
    computedDateFormatted() {
      return this.formatDate(this.last_import_since);
    },
    formattedMinDiscount: {
      get: function () {
        let value = this.form.min_discount;
        return value ? value * 100 : null;
      },
      set: function (newValue) {
        if (newValue) this.form.min_discount = newValue / 100;
        else this.form.min_discount = null;
      },
    },
    last_import_sinceFormatted() {
      return this.last_import_since ? moment(this.last_import_since).format("DD/MM/YYYY") : "";
    },
    isValidForm() {
      let valid = true;
      if (!this.form.approach_id) valid = false;
      if (!this.form.name) valid = false;
      if (!this.form.creditor_id) valid = false;
      if (
        (!this.form.days_to_wait && this.form.days_to_wait !== 0) ||
        this.form.days_to_wait === ""
      )
        valid = false;

      return valid;
    },
    isValidToSimulate() {
      let valid = true;
      if (this.loadingSimulation) valid = false;
      if (!this.form.creditor_id) valid = false;
      if (
        (!this.form.days_to_wait && this.form.days_to_wait !== 0) ||
        this.form.days_to_wait === ""
      )
        valid = false;
      return valid;
    },
    setApproaches() {
      let array = [];
      this.approaches.forEach((element) => {
        if (typeof element.type !== "undefined")
          if (this.form.typeApproach == element.type) array.push(element);
      });
      return array;
    },
  },
  methods: {
    formatDate(date) {
      if (!date) return null;

      date = date.trim();

      const [year, month, day] = date.split("-");
      return `${day}/${month}/${year}`;
    },
    parseDate(date) {
      if (!date) return null;

      date = date.trim();

      const [day, month, year] = date.split("/");
      return `${year}-${month.padStart(2, "0")}-${day.padStart(2, "0")}`;
    },
    async getStrategy(strategy_id) {
      let vm = this;
      await strategyService.findById(strategy_id).then((res) => {
        vm.loadStrategy(res);
      });
    },

    pasteDate(event) {
      this.last_import_since = event.clipboardData.getData("text");
    },

    loadStrategy(strategy) {
      let vm = this;
      vm.form = Object.assign(vm.form, strategy);
      // vm.searchApproach(vm.form.creditor_id);
      vm.form.typeApproach = vm.form.approach.type;
      vm.publicType = vm.addButtons.find((e) => e.value == vm.form.public);

      vm.payment_methods = [];
      if (vm.form.payment_methods) vm.payment_methods = vm.form.payment_methods.split(",");

      vm.responsible_types = [];
      if (vm.form.responsible_types) vm.responsible_types = vm.form.responsible_types.split(",");

      vm.contact_source = [];
      if (vm.form.contact_source) vm.contact_source = vm.form.contact_source.split(",");

      vm.conditions = [];
      if (vm.form.personal == true) vm.conditions.push("1");
      if (vm.form.business == true) vm.conditions.push("2");
      if (vm.form.only_waiting_deals == true) vm.conditions.push("3");
      // if (vm.form.has_selected_proposal == true) vm.conditions.push('4')
      // if (vm.form.has_simulated_proposal == true) vm.conditions.push('5')
      vm.loadDates();
      vm.loadShipsFields();
      vm.form = Object.assign({}, vm.form);

      vm.dialog = true;
    },

    getCreditors() {
      creditorService
        .list()
        .then((res) => (this.creditors = res.objects))
        .catch((err) => console.error(err));
    },
    loadDates() {
      if (this.form) {
        // if (this.form.contact_date) {
        //   this.contact_date = this.form.contact_date.substr(0, 10);
        // }
        if (this.form.last_import_since) {
          this.last_import_since = this.form.last_import_since.substr(0, 10);
        }
      }
    },

    loadShipsFields() {
      this.dealTagsModelV2 = [];
      this.contactTagsModel = [];
      this.selected_ddd = [];
      this.contactTagsV2 = [];
      this.customerTagsV2 = [];
      this.amountDealsModel = [];
      this.profileKeyModel = [];
      this.segmentChip = [];
      this.ddd_method = [];

      if (this.form.selected_ddd != undefined && this.form.selected_ddd != "") {
        this.selected_ddd = this.form.selected_ddd.split(",");
      }
      if (this.form.contact_tags_v2 != undefined && this.form.contact_tags_v2 != "") {
        this.contactTagsV2 = this.form.contact_tags_v2.split(",");
      }
      if (this.form.customer_tag != undefined && this.form.customer_tag != "") {
        this.customerTagsV2 = this.form.customer_tag.split(",");
      }
      if (this.form.amount_deals != undefined && this.form.amount_deals != "") {
        this.amountDealsModel = this.form.amount_deals.split(",");
      }
      if (this.form.segment != undefined && this.form.segment != "") {
        this.segmentChip = this.form.segment.split(",");
      }
      if (this.form.SegmentFilter != undefined && this.form.SegmentFilter != "") {
        this.segmentChip = this.form.SegmentFilter.split(",");
      }
      if (this.form.profile_key != undefined && this.form.profile_key != "") {
        this.profileKeyModel = this.form.profile_key.split(",");
      }
      if (this.form.tags_v2 != undefined && this.form.tags_v2 != "") {
        this.dealTagsModelV2 = this.form.tags_v2.split(",");
      }
    },
    async saveStrategy() {
      await this.prepareToPost();
      let form = Object.assign({}, this.form);
      strategyService
        .save(form)
        .then((res) => {
          if (res == undefined) {
            console.error("houve um erro");
            this.$store.commit("showSnackbar", {
              message: "Houve um erro ao salvar",
            });
          } else {
            this.$store.commit("showSnackbar", {
              message: "Estratégia salva com sucesso!",
              important: true,
            });

            this.dialog = false;
            this.form = Object.assign({}, this.strategyBlank);
            this.$emit("fetched", this.publicType.value);
          }
        })
        .catch((error) => {
          this.$store.commit("showSnackbar", {
            message: "Houve um erro ao salvar",
          });
          console.error("Houve um erro", error);
        });
    },
    prepareToPost() {
      const noProfileKeyIndex = this.profileKeyModel.findIndex((item) => item == "Sem-perfil");
      if (noProfileKeyIndex >= 0) {
        this.profileKeyModel[noProfileKeyIndex] = { name: "Sem-perfil" };
      }
      if (this.profileKeyModel[0] && this.profileKeyModel[0]["name"]) {
        if (this.profileKeyModel[0])
          this.form.profile_key = this.profileKeyModel.map((item) => item.name).join(",");
      } else {
        this.form.profile_key = this.profileKeyModel.join(",");
      }

      const noSegmentIndex = this.segmentChip.findIndex((item) => item == "Sem-segmento");
      if (noSegmentIndex >= 0) {
        this.segmentChip[noSegmentIndex] = { name: "Sem-segmento" };
      }
      if (this.segmentChip[0] && this.segmentChip[0]["name"]) {
        this.form.segment = this.segmentChip.map((item) => item.name).join(",");
      } else {
        this.form.segment = this.segmentChip.join(",");
      }

      const noTagsIndex = this.dealTagsModelV2.findIndex((item) => item == "Sem-tags");
      if (noTagsIndex >= 0) {
        this.dealTagsModelV2[noTagsIndex] = { name: "Sem-tags" };
      }
      if (this.dealTagsModelV2[0] && this.dealTagsModelV2[0]["name"]) {
        this.form.tags_v2 = this.dealTagsModelV2.map((item) => item.name).join(",");
      } else {
        this.form.tags_v2 = this.dealTagsModelV2.join(",");
      }

      const noContactTagsIndex = this.contactTagsV2.findIndex((item) => item == "Sem-tags");
      if (noContactTagsIndex >= 0) {
        this.contactTagsV2[noContactTagsIndex] = { name: "Sem-tags" };
      }
      if (this.contactTagsV2[0] && this.contactTagsV2[0]["name"]) {
        this.form.contact_tags_v2 = this.contactTagsV2.map((item) => item.name).join(",");
      } else {
        this.form.contact_tags_v2 = this.contactTagsV2.join(",");
      }

      if (this.customerTagsV2[0] && this.customerTagsV2[0]["name"]) {
        this.form.customer_tag = this.customerTagsV2.map((item) => item.name).join(",");
      } else {
        this.form.customer_tag = this.customerTagsV2.join(",");
      }

      this.form.last_import_since = this.last_import_since
        ? (this.form.last_import_since = new Date(this.last_import_since)
            .toISOString()
            .substr(0, 19))
        : new Date().toISOString();

      this.form.selected_ddd = this.selected_ddd.join(",");
      this.form.amount_deals = this.amountDealsModel.join(",");
      this.form.ddd_method = this.form.ddd_method == null ? null : this.form.ddd_method;

      this.form.min_debit = this.form.min_debit == "" ? null : this.form.min_debit;
      this.form.max_debit = this.form.max_debit == "" ? null : this.form.max_debit;
      this.form.min_potential = this.form.min_potential == "" ? null : this.form.min_potential;
      this.form.max_potential = this.form.max_potential == "" ? null : this.form.max_potential;
      this.form.min_days_of_delay =
        this.form.min_days_of_delay == "" ? null : this.form.min_days_of_delay;
      this.form.max_days_of_delay =
        this.form.max_days_of_delay == "" ? null : this.form.max_days_of_delay;
      this.form.max_notifications =
        this.form.max_notifications == "" ? null : this.form.max_notifications;
      this.form.min_notifications =
        this.form.min_notifications == "" ? null : this.form.min_notifications;
      this.form.limit = this.form.limit == "" ? null : this.form.limit;
      this.form.max_contact_count =
        this.form.max_contact_count == undefined ? null : this.form.max_contact_count;
      this.form.contact_min_final_score =
        this.form.contact_min_final_score == "" ? null : this.form.contact_min_final_score;
      this.form.contact_max_final_score =
        this.form.contact_max_final_score == "" ? null : this.form.contact_max_final_score;
      this.form.min_discount = this.form.min_discount == "" ? null : this.form.min_discount;
      this.form.max_discount = this.form.max_discount == "" ? null : this.form.max_discount;
      this.form.min_digit = this.form.min_digit == "" ? null : this.form.min_digit;
      this.form.max_digit = this.form.max_digit == "" ? null : this.form.max_digit;
      this.form.min_interaction_days =
        this.form.min_interaction_days == "" ? null : this.form.min_interaction_days;
      this.form.max_interaction_days =
        this.form.max_interaction_days == "" ? null : this.form.max_interaction_days;
      this.form.min_payment_expired_days =
        this.form.min_payment_expired_days == "" ? null : this.form.min_payment_expired_days;
      this.form.max_payment_expired_days =
        this.form.max_payment_expired_days == "" ? null : this.form.max_payment_expired_days;

      this.form.contact_tags_v2 =
        this.form.contact_tags_v2 == "" ? null : this.form.contact_tags_v2;

      this.form.customer_tag = this.form.customer_tag == "" ? null : this.form.customer_tag;

      this.form.tags_v2 = this.form.tags_v2 == "" ? null : this.form.tags_v2;
      if (this.payment_methods) {
        let payment_methods = [];
        this.payment_methods.forEach((element) => {
          payment_methods.push(element);
        });
        this.form.payment_methods = payment_methods.join(",");
      } else this.form.payment_methods = null;

      if (!this.form.campaign_v2) this.form.campaign_v2 = null;

      if (this.responsible_types) {
        let responsible_types = [];
        this.responsible_types.forEach((element) => {
          responsible_types.push(element);
        });
        this.form.responsible_types = responsible_types.join(",");
      } else this.form.responsible_types = null;

      if (this.contact_source) {
        let contact_source = [];
        this.contact_source.forEach((element) => {
          contact_source.push(element);
        });
        this.form.contact_source = contact_source.join(",");
      } else this.form.contact_source = null;

      this.form.personal = false;
      this.form.business = false;
      this.form.only_waiting_deals = false;

      if (this.conditions) {
        this.conditions.forEach((element) => {
          switch (element) {
            case "1":
              this.form.personal = true;
              break;
            case "2":
              this.form.business = true;
              break;
            case "3":
              this.form.only_waiting_deals = true;
              break;
          }
        });
      }
    },
    async taskSimulate() {
      clearInterval(this.interval);
      await this.prepareToPost();
      this.loadingSimulation = !this.loadingSimulation;

      this.simulationFailureText = null;
      this.sameSimulationCustomers = false;
      this.sameSimulationNotification = false;

      await tasksService
        .strategySimulate(this.objectSimulate())
        .then(async (res) => {
          this.taskId = res.task_id;
          this.checkSimulation();
        })
        .catch((err) => {
          this.simulationFailureText = "Simulação Falhou";
          this.$store.commit("showSnackbar", "Houve um erro ao simular a estratégia");
          console.error(err);
        });
    },
    checkSimulation() {
      this.interval = setInterval(async () => {
        tasksService
          .get(this.taskId)
          .then(async (res) => {
            if (res.state == "SUCCESS") {
              clearInterval(this.interval);
              this.changeSimulationNotificationNumber(res.result.contacts);
              this.changeSimulationCustomersNumber(res.result.customers);
              this.loadingSimulation = false;
            } else if (res.state == "FAILURE") {
              this.simulationFailureText = "Simulação Falhou";
              clearInterval(this.interval);
              this.changeSimulationNotificationNumber();
              this.changeSimulationCustomersNumber();
              this.loadingSimulation = false;
            }
          })
          .catch((err) => {
            this.simulationFailureText = "Simulação Falhou";
            console.error(err);
            clearInterval(this.interval);
            this.changeSimulationNotificationNumber();
            this.changeSimulationCustomersNumber();
            this.loadingSimulation = false;
          })
          .finally((res) => {});
      }, 2000);
    },
    objectSimulate() {
      let result = {
        amount_deals: this.isUndefined("amount_deals"),
        policies_method: this.isUndefined("policies_method"),
        ddd_method: this.isUndefined("ddd_method"),
        only_waiting_deals: this.isUndefined("only_waiting_deals"),
        indicator_good_interest: this.isUndefined("indicator_good_interest"),
        indicator_bad_interest: this.isUndefined("indicator_bad_interest"),
        value_type: this.isUndefined("value_type"),

        indicator_bad_accessed: this.isUndefined("indicator_bad_accessed"),
        only_enrichment: this.isUndefined("only_enrichment"),
        only_notification_sent: this.isUndefined("only_notification_sent"),
        indicator_good_accessed: this.isUndefined("indicator_good_accessed"),
        max_debit: this.isUndefined("max_debit"),
        max_potential: this.isUndefined("max_potential"),
        last_notification_count: this.isUndefined("last_notification_count"),
        indicator_bad_implantation: this.isUndefined("indicator_bad_implantation"),
        creditor_id: this.isUndefined("creditor_id"),
        last_import_since: this.last_import_since + "T00:00:00",

        creditor: {},

        min_payment_expired_days: this.isUndefined("min_payment_expired_days"),
        max_payment_expired_days: this.isUndefined("max_payment_expired_days"),
        payment_methods: this.isUndefined("payment_methods"),
        apply_tags: this.isUndefined("apply_tags"),
        business: this.isUndefined("business"),
        min_days_of_delay: this.isUndefined("min_days_of_delay"),
        approach: {
          type: this.isUndefined("typeApproach"),
        },

        max_notifications: this.isUndefined("max_notifications"),
        min_notifications: this.isUndefined("min_notifications"),
        campaign_v2: this.isUndefined("campaign_v2"),
        segment: this.isUndefined("segment"),
        profile_key: this.isUndefined("profile_key"),
        tags_v2: this.isUndefined("tags_v2"),
        contact_min_final_score: this.isUndefined("contact_min_final_score"),
        contact_max_final_score: this.isUndefined("contact_max_final_score"),
        min_discount: this.isUndefined("min_discount"),
        max_discount: this.isUndefined("max_discount"),
        min_digit: this.isUndefined("min_digit"),
        max_digit: this.isUndefined("max_digit"),
        responsible_types: this.isUndefined("responsible_types"),
        max_contact_count: this.isUndefined("max_contact_count"),
        contact_source: this.isUndefined("contact_source"),
        personal: this.isUndefined("personal"),
        selected_ddd: this.isUndefined("selected_ddd"),
        contact_tags_v2: this.isUndefined("contact_tags_v2"),
        customer_tag: this.isUndefined("customer_tag"),
        min_debit: this.isUndefined("min_debit"),
        min_potential: this.isUndefined("min_potential"),

        public: this.isUndefined("public"),

        exclude_interactions: this.isUndefined("exclude_interactions"),

        indicator_bad_cpp: this.isUndefined("indicator_bad_cpp"),
        deal_type: this.isUndefined("deal_type"),
        multicreditor: this.isUndefined("multicreditor"),
        not_only_enrichment: this.isUndefined("not_only_enrichment"),
        not_only_notification_sent: this.isUndefined("not_only_notification_sent"),
        max_days_of_delay: this.isUndefined("max_days_of_delay"),
        last_notification_user: this.isUndefined("last_notification_user"),
        days_to_wait: this.isUndefined("days_to_wait"),
        min_interaction_days: this.isUndefined("min_interaction_days"),
        max_interaction_days: this.isUndefined("max_interaction_days"),
        indicator_good_cpp: this.isUndefined("indicator_good_cpp"),
        indicator_good_implantation: this.isUndefined("indicator_good_implantation"),
        limit: this.isUndefined("limit"),
      };

      if (this.publicType.value !== "UNCHECKED") {
        delete result["not_only_notification_sent"];
        delete result["only_notification_sent"];
      }

      return result;
    },
    isUndefined(index) {
      return typeof this.form[index] !== "undefined" ? this.form[index] : null;
    },
    async changeSimulationNotificationNumber(newNumber = 0) {
      if (newNumber == this.simulationNotification) {
        this.sameSimulationNotification = true;
        this.activeIconSimulationNotificationDown = false;
        this.activeIconSimulationNotificationUp = false;
        this.diffSimulationNotification = 0;
        this.oldSimulationNotification = newNumber;
        this.animateSameResult("simulation");
        return;
      } else {
        this.oldSimulationNotification = this.simulationNotification;
      }

      if (newNumber > this.simulationNotification) {
        let range = this.setRange(newNumber);
        this.activeIconSimulationNotificationDown = false;
        this.activeIconSimulationNotificationUp = true;
        for (let i = this.simulationNotification; i <= newNumber; i += range) {
          await this.sleep(10).then(() => (this.simulationNotification = i));
        }
      } else {
        let range = this.setRange(this.simulationNotification);
        this.activeIconSimulationNotificationUp = false;
        this.activeIconSimulationNotificationDown = true;
        for (let i = this.simulationNotification; i >= newNumber; i -= range) {
          await this.sleep(1).then(() => (this.simulationNotification = i));
        }
      }
      if (this.simulationNotification != newNumber) {
        this.simulationNotification = newNumber;
        this.diffSimulationNotification = newNumber - this.oldSimulationNotification;
      }
    },
    async changeSimulationCustomersNumber(newNumber = 0) {
      if (newNumber == this.simulationCustomers) {
        this.activeIconSimulationCustomersDown = false;
        this.activeIconSimulationCustomersUp = false;
        this.diffSimulationCustomers = 0;
        this.oldSimulationCustomers = newNumber;
        this.animateSameResult("customers");
        return;
      } else {
        this.oldSimulationCustomers = this.simulationCustomers;
      }

      if (newNumber > this.simulationCustomers) {
        let range = this.setRange(newNumber);
        this.activeIconSimulationCustomersDown = false;
        this.activeIconSimulationCustomersUp = true;
        for (let i = this.simulationCustomers; i <= newNumber; i += range) {
          await this.sleep(10).then(() => (this.simulationCustomers = i));
        }
      } else {
        let range = this.setRange(this.simulationCustomers);
        this.activeIconSimulationCustomersUp = false;
        this.activeIconSimulationCustomersDown = true;
        for (let i = this.simulationCustomers; i >= newNumber; i -= range) {
          await this.sleep(1).then(() => (this.simulationCustomers = i));
        }
      }
      if (this.simulationCustomers != newNumber) {
        this.simulationCustomers = newNumber;
        this.diffSimulationCustomers = newNumber - this.oldSimulationCustomers;
      }
    },
    sleep(ms) {
      return new Promise((resolve) => setTimeout(resolve, ms));
    },
    setRange(number) {
      number = number + "";
      let range = "";
      let max = number[0] == "1" ? number.length - 1 : number.length;
      for (let i = 0; i < max; i++) {
        if (range == "") range = "1";
        else range += "0";
      }
      return parseInt(range);
    },
    setConditionsItems(type) {
      let items = [
        {
          id: "1",
          text: "Pessoa Física",
        },
        {
          id: "2",
          text: "Pessoa Jurídica",
        },
      ];
      if (type === "LOCATED") {
        items.push({
          id: "3",
          text: "Apenas negociações prorrogadas",
        });
      }
      return items;
    },
    animateSameResult(ref) {
      let element = this.$refs[ref];
      if (element.length) element = element[0];
      let time_ = 128;
      let opacity;
      let interval = setInterval(() => {
        time_--;
        opacity = time_ < 10 ? "0" + time_ : time_;
        element.style.color = `rgb(0,${opacity},0)`;
        if (!time_) {
          clearInterval(interval);
          element.style.color = "black";
        }
      }, 25);
    },
  },
};
</script>

<style>
.v-select__selections {
  width: calc(100% - 28px);
}
</style>
